// src/components/SimpleComponents/SimpleGender.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState, useCallback } from 'react';
import { Select } from 'antd';
import SimpleFormItem from './SimpleFormItem';
import translateX from 'utils/translateX';
import useFormElement from '../../hooks/useFormElement';
import { defaultSelectFilterOption } from 'utils/helpers';
import { useSimpleFormContext } from './SimpleFormProvider';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// FUNCTIONS
// *******************************************************************************
function $buildOptions() {
  return [
    {
      value: 'female',
      text: translateX('female'),
      label: translateX('female'),
      disabled: false,
      level: 1,
    },
    {
      value: 'male',
      text: translateX('male'),
      label: translateX('male'),
      disabled: false,
      level: 1,
    },
    {
      value: 'prefer_not_inform',
      text: translateX('prefer_not_inform'),
      label: translateX('prefer_not_inform'),
      disabled: false,
      level: 2,
    },
  ];
}

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleGender = ({
  name,
  subdocumentField,
  level = 1,
  options = $buildOptions(),
  showSearch = true,
  allowClear,
  disabled,
  ...props
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { locked, disabledFields } = useSimpleFormContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const elementProps = useFormElement(name, subdocumentField);
  const { elementRef, fullFieldName, flattenFieldName } = elementProps;

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const isDisabled = disabled || locked || disabledFields?.includes(flattenFieldName);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [open, setOpen] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  // ANTD v6 fix: controlled open state ensures dropdown closes on first click
  const handleSelect = useCallback(() => {
    setOpen(false);
  }, []);

  const handleDropdownVisibleChange = useCallback(visible => {
    setOpen(visible);
  }, []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <SimpleFormItem {...props} name={fullFieldName} elementProps={elementProps}>
      <Select
        ref={elementRef}
        id={flattenFieldName}
        filterOption={defaultSelectFilterOption}
        options={options}
        showSearch={showSearch}
        allowClear={allowClear}
        disabled={isDisabled}
        open={open}
        onSelect={handleSelect}
        onOpenChange={handleDropdownVisibleChange}
      />
    </SimpleFormItem>
  );
};

export default SimpleGender;
